import TextField, { type TextFieldProps } from "@mui/material/TextField";

export type InputProps = TextFieldProps;

/** Presentational wrapper around MUI's TextField for consistent form styling. */
export function Input(props: InputProps) {
  return <TextField fullWidth size="medium" variant="outlined" {...props} />;
}
